/**
 * Evaluates a server-sent expression in a controlled scope.
 * Uses new Function() instead of eval() to avoid security/minification warnings
 * while still supporting dynamic expressions (e.g. for chart colors: "close > open ? '#00ff00' : '#ff0000'").
 *
 * @param expression - The expression string from the server (e.g. "close > open ? '#00ff00' : '#ff0000'")
 * @param context - Variables available in the expression (open, close, series, candle, index, etc.)
 * @returns The evaluated result
 */
export function evaluateExpression<T = unknown>(
    expression: string,
    context: Record<string, unknown>
): T {
    const keys = Object.keys(context)
    const values = Object.values(context)
    const fn = new Function(...keys, `return (${expression})`)
    return fn(...values) as T
}
